export const getIssuesDefaultParams = () => ({ issueStatus: "open" })

export const addFixableToLink = (link: string) =>
  `${link}${!link ? "?" : "&"}fixable=YES`
